<div class="idd-escalation-thresholds">
  <app-panel>
    <div class="monthly-thresholds-header">
      <h3>
        {{ 'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-MONTHLY-THRESHOLDS' | translate }}
      </h3>

      <dx-button
        *ngIf="iddEscalationThresholds.length < months.length"
        type="normal"
        icon="plus"
        [text]="'SETTINGS.IDD-ESCALATION.ADD-MONTH' | translate"
        (onClick)="addIddEscalationThreshold()"
      ></dx-button>
    </div>

    <dx-data-grid
      #iddEscalationGrid
      [dataSource]="iddEscalationThresholds"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="false"
      [width]="'auto'"
      (onInitNewRow)="onIddEscalationThresholdAdding($event)"
      (onEditorPreparing)="onEditorPreparing($event)"
      (onRowInserted)="onThresholdsChanged()"
      (onRowUpdated)="onThresholdsChanged()"
      (onRowRemoved)="onThresholdsChanged()"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [useIcons]="true"
        [confirmDelete]="false"
        [texts]="{
          saveRowChanges: ('COMMON.SAVE' | translate),
          cancelRowChanges: ('COMMON.CANCEL' | translate),
        }"
      ></dxo-editing>

      <dxi-column
        dataField="evaluationMonth"
        [caption]="
          'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-EVALUATION-MONTH' 
            | translate
        "
        [width]="350"
        sortOrder="asc"
      >
        <dxo-lookup
          [dataSource]="months"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>

        <dxi-validation-rule
          type="required"
          [message]="
            'VALIDATIONS.IDD-ESCALATION-EVALUATION-MONTH-REQUIRED' | translate
          "
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="thresholdMinutes"
        [caption]="
          'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-THRESHOLD-MINUTES' 
            | translate
        "
        cellTemplate="thresholdCell"
        editCellTemplate="thresholdEditCell"
        [alignment]="'left'"
      >
        <div *dxTemplate="let cellInfo of 'thresholdCell'">
          {{ formatIddEscalationThreshold(cellInfo.value) }}
        </div>

        <div
          *dxTemplate="let cellInfo of 'thresholdEditCell'"
          class="threshold-time-picker"
        >
          <app-time-picker
            [isInvalid]="false"
            [defaultValue]="getTimePickerValue(cellInfo.value)"
            [minHours]="minIddEscalationHours"
            [maxHours]="maxIddEscalationHours"
            [validationMessage]="'VALIDATIONS.IDD-ESCALTION-TIME-RANGE' | translate"
            (timeChanged)="handleMonthlyIddEscalationTimePicker(cellInfo, $event)"
          ></app-time-picker>
        </div>

        <dxi-validation-rule
          type="required"
          [message]="
            'VALIDATIONS.IDD-ESCALATION-THRESHOLD-REQUIRED' | translate
          "
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </app-panel>
</div>